/** @module SourcingOrders/ToolbarPluginPOProduct */
define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		resDefault: "SelectAll",
		switchboardPath: "Child:POProducts",

		/**
		 * Do nothing - idViewProperty handles it all
		 */
		onChangeItem: function(view, node) {
			this.inherited(arguments, [view, node || view.getPO()])
		}
	});
});